<template>
  <div class="titleBreadCrumb">
    <div class="title">{{ nowData }}</div>
    <div class="bread">
      当前位置：
      <el-breadcrumb :separator-icon="ArrowRight">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <!-- <el-breadcrumb-item>走进攀发展</el-breadcrumb-item> -->
        <el-breadcrumb-item>{{ nowData }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>
<script setup>
import { ArrowRight } from '@element-plus/icons-vue';
import { onMounted, reactive, ref, defineProps, defineEmits, watch } from 'vue';
const props = defineProps({
  nowData: {
    type: String,
    default: () => {
      return {};
    },
  },
  title: {
    type: Object,
    default: () => {
      return {};
    },
  },
});
console.log(props);
</script>
<style lang="less" scoped>
.titleBreadCrumb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 20px;
  .title {
    font-size: 22px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
  .bread {
    display: flex;
    align-items: center;
    font-size: 14px;
    height: 14px;
  }
}
.el-breadcrumb {
  line-height: normal;
}
</style>

<style lang="less">
.el-breadcrumb__item:nth-child(2) .el-breadcrumb__inner {
  color: #2270ac !important;
}
</style>
